import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoginData } from '../../store/actions/login';
import localStorage from '../../services/localStorage';
import jwtDecode from 'jwt-decode';

const BootstrapManager = ({ children }) => {
  const accessToken = localStorage.getAccessToken();
  const dispatch = useDispatch();

  const [displayContent, setDisplayContent] = useState(false);

  useEffect(() => {
    if (accessToken) {
      const decoded = jwtDecode(accessToken);
      dispatch(setLoginData({ token: accessToken, username: decoded.username, name: decoded.name, role: decoded.role }));
    }
    setDisplayContent(true);
  }, [dispatch, accessToken]);

  return <>{displayContent && children}</>;
};

export default BootstrapManager;
